import { html, View } from 'rune-ts';
import klass from './LimitedSaleSelectField.module.scss';
import { font } from '../../../../../shared/typography';
import { ProductBadgeFactory } from '../../../../../renderApp/components/cells/ProductBadge/ProductBadgeFactory';
import { NessProductBadgeFactory } from '../../../../../../../modules/Ness/App/ProductBadge/S/Function/NessProductBadgeFactory';
import { isNessApp } from '../../../../../../../modules/Util/S/Function/module';
import { SpecialOfferBadge } from '../../../../../../../modules/Ness/App/ProductBadge/S/Function/badge/SpecialOfferBadge';
import { LimitedBadge } from '../../../../../renderApp/components/cells/ProductBadge/badge';
import { ProductBadgeSize, ProductBadgeType } from '@services/MarppleShop/features/ProductBadge/type';

export class LimitedSaleSelectField extends View<{
  klass?: string;
}> {
  private readonly StaticLimitedBadge: SpecialOfferBadge | LimitedBadge;

  constructor(props: { klass?: string } = {}) {
    super(props);

    // 나중에 로직 분리하기
    this.StaticLimitedBadge = isNessApp()
      ? NessProductBadgeFactory.create(NessProductBadgeFactory.Type.SpecialOffer, {
          klass: klass.badge,
        })
      : ProductBadgeFactory.create(ProductBadgeType.LIMITED, {
          value: undefined,
          option: {
            lang: ET.lang,
            size: ProductBadgeSize.small,
            klass: klass.badge,
          },
        });
  }

  override template() {
    const footer_text = html`한정 판매 종료일 또는 한정 판매 수량 설정 시 ${this.StaticLimitedBadge}으로
    표시됩니다.`;

    return html`<div class="${klass.LimitedSaleSelectField} ${this.data.klass || ''}">
      <span class="${klass.footer_text} ${font('13_regular')}">${footer_text}</span>
    </div>`;
  }
}
